import type { StylesConfig } from 'react-select'

/** Shared react-select look for INCYIA forms (teal focus, Lato, compact control). */
export const incyiaSelectStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    minHeight: 40,
    height: 'auto',
    borderRadius: 8,
    borderColor: state.isFocused ? '#0D9B87' : '#DFE7E8',
    boxShadow: state.isFocused
      ? '0 0 0 3px rgba(13, 155, 135, 0.14)'
      : 'none',
    backgroundColor: '#fff',
    fontFamily: 'Lato, sans-serif',
    fontSize: 15,
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    opacity: state.isDisabled ? 0.65 : 1,
    '&:hover': {
      borderColor: state.isFocused ? '#0D9B87' : '#8A9BA7',
    },
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    padding: '2px 10px',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#8A9BA7',
    fontSize: 15,
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: '#0B1E2D',
    fontWeight: 500,
    fontSize: 15,
  }),
  multiValue: (provided: any) => ({
    ...provided,
    backgroundColor: '#E1F4F0',
    borderRadius: 999,
  }),
  multiValueLabel: (provided: any) => ({
    ...provided,
    color: '#076B5C',
    fontWeight: 600,
    fontSize: 13,
  }),
  multiValueRemove: (provided: any) => ({
    ...provided,
    color: '#076B5C',
    borderRadius: 999,
    ':hover': {
      backgroundColor: '#C8EBE4',
      color: '#055A4D',
    },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: '#5F7484',
    padding: '0 10px',
  }),
  clearIndicator: (provided: any) => ({
    ...provided,
    color: '#8A9BA7',
  }),
  menu: (provided: any) => ({
    ...provided,
    borderRadius: 10,
    border: '1px solid #DFE7E8',
    boxShadow: '0 16px 40px rgba(6, 21, 36, 0.14)',
    overflow: 'hidden',
    zIndex: 9999,
    fontFamily: 'Lato, sans-serif',
    // Base size is smaller because menuPortal uses zoom:1.25 (html zoom compensation)
    fontSize: 12,
  }),
  menuPortal: (provided: any) => ({
    ...provided,
    // Above form fields and MUI dialogs. Menus portal to document.body.
    zIndex: 10000,
    zoom: 1.25,
  }),
  menuList: (provided: any) => ({
    ...provided,
    padding: 4,
    maxHeight: '50vh',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    borderRadius: 7,
    margin: '1px 0',
    padding: '5px 8px',
    fontSize: 12,
    fontWeight: state.isSelected ? 600 : 500,
    lineHeight: 1.3,
    backgroundColor: state.isSelected
      ? '#E1F4F0'
      : state.isFocused
        ? '#F7FAFA'
        : '#FFFFFF',
    color: state.isSelected ? '#076B5C' : '#0B1E2D',
    cursor: 'pointer',
    ':active': {
      backgroundColor: '#D2EFE8',
    },
  }),
} as StylesConfig<any, any>
